export default "__VITE_ASSET__BXZ1FgCi__"